import {
  PostJourneysSearchJourneyRequest,
  PostStandbyGetAlternativeOffersResponseFlightOffersInner,
  PostStandbyGetAlternativeOffersResponseTravelersInner,
} from 'src/sdk_checkin';

/**
 * CheckinCommon model
 * @param journeyId チェックイン検索にて取得された、チェックイン対象journeyId
 * @param searchType チェックイン検索にて指定された検索条件
 * @param orderId チェックイン検索の際に指定された予約番号
 * @param travelDocumentId チェックイン検索の際に指定された航空券番号
 * @param firstName チェックイン検索の際に指定された搭乗者の名
 * @param lastName チェックイン検索の際に指定された搭乗者の姓
 * @param searchedTravelerName チェックイン検索の際に指定された搭乗者の姓名
 * @param numberOfTravelers journeyに含まれる搭乗者の数(同伴幼児を含まない)
 * @param selectedFlightIds チェックイン対象として選択された、セグメントのID配列
 * @param previousPageIdentifier どの画面からの遷移かを示す識別子
 * @param seatMapDisplayFlightId シートマップ表示セグメントID
 * @param reservationDetailIdentifier 予約詳細からの遷移かどうかを示す識別子
 * @param departureLocationCode 検索条件として選択された出発空港コード
 * @param departureAirportName 検索条件として選択された出発空港名(表示言語用)
 * @param arrivalLocationCode 検索条件として選択された到着空港コード
 * @param arrivalAirportName 検索条件として選択された到着空港名(表示言語用)
 * @param departureDate 検索ボタン押下時の現在時刻（JST）
 * @param departureTimeFrom 検索条件として選択された検索開始出発時刻
 * @param departureTimeTo 検索条件として選択された検索終了出発時刻
 * @param originalFlightId 空席待ちのオリジナル便セグメントID
 * @param originalFlightIdOffer 空席待ちのオリジナル便セグメントID※CM Open APIの形式 (例：NH803720241122HND)
 * @param selectedFlightOffer 選択された空席待ち候補便情報
 * @param travelersOffer 空席待ちのオリジナル便に対する搭乗者情報リスト
 * @param previousPointOfSaleId 変更前オフィスコード
 * @param previousLang 変更前言語情報
 * @param retryableErrorMsgId 空席待ち候補便情報が返却されなかった場合のエラーコード
 * @param isPassengerAdded 同行者追加実施フラグ
 * @param isSkipCheckinPassengerInput チェックイン搭乗者情報入力画面スキップフラグ
 * @param isSkipCheckinSeatmap チェックインシートマップ画面スキップフラグ
 * @param isGetOrderSkipped PNR情報取得APIスキップフラグ
 */
export interface CheckinCommonModel {
  journeyId?: string;
  searchType?: PostJourneysSearchJourneyRequest.SearchTypeEnum;
  orderId?: string;
  travelDocumentId?: string;
  firstName?: string;
  lastName?: string;
  searchedTravelerName?: string;
  numberOfTravelers?: number;
  selectedFlightIds?: string[];
  previousPageIdentifier?: string;
  seatMapDisplayFlightId?: string;
  reservationDetailIdentifier?: typeof RESERVATION_DETAIL_IDENTIFIER | '';
  departureLocationCode?: string;
  departureAirportName?: string;
  arrivalLocationCode?: string;
  arrivalAirportName?: string;
  departureDate?: string;
  departureTimeFrom?: string;
  departureTimeTo?: string;
  originalFlightId?: string;
  originalFlightIdOffer?: string;
  selectedFlightOffer?: PostStandbyGetAlternativeOffersResponseFlightOffersInner;
  travelersOffer?: PostStandbyGetAlternativeOffersResponseTravelersInner[];
  previousPointOfSaleId?: string;
  previousLang?: string;
  retryableErrorMsgId?: string;
  isPassengerAdded?: boolean;
  isSkipCheckinPassengerInput?: boolean;
  isSkipCheckinSeatmap?: boolean;
  isGetOrderSkipped?: boolean;
}

// 予約詳細から遷移してきたことを示す識別子
export const RESERVATION_DETAIL_IDENTIFIER = 'reservation';
